// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { User } from '../../types'

type Props = {
  user: User,
  router: Object,
  isAuthenticated: boolean,
  willAuthenticate: boolean
}

export default function authenticateAdmin(WrappedComponent: any) {
  class AuthenticateAdmin extends Component {
    componentDidMount() {
      if (
        (!this.props.willAuthenticate && !this.props.isAuthenticated) ||
        (this.props.isAuthenticated && !this.props.user.admin)
      ) {
        this.props.router.push('/')
      }
    }

    componentWillReceiveProps(nextProps: Props) {
      if (
        (!this.props.willAuthenticate && !this.props.isAuthenticated) ||
        (nextProps.isAuthenticated && !nextProps.user.admin)
      ) {
        this.props.router.push('/')
      }
    }

    props: Props

    render() {
      if (this.props.willAuthenticate) {
        return null
      }

      return <WrappedComponent {...this.props} />
    }
  }

  return connect((state) => ({
    user: state.session.currentUser,
    isAuthenticated: state.session.isAuthenticated,
    willAuthenticate: state.session.willAuthenticate
  }))(AuthenticateAdmin)
}



// WEBPACK FOOTER //
// ./src/containers/AuthenticateAdmin/index.js